import { useQuery } from '@tanstack/react-query';
import type { BackInStockSubscriberToken } from '@sleed/bizcommerce-api';
import { backInStockSubscriptionsApi } from '~/lib/api/client';

export const backInStockSubscriptionKeys = { all: ['back-in-stock-subscriptions'] as const, list: () => [...backInStockSubscriptionKeys.all, 'list'] as const };

export function useBackInStockSubscriptionsList() {
	return useQuery<BackInStockSubscriberToken[]>({
		queryKey: backInStockSubscriptionKeys.list(),
		queryFn: async () => (await backInStockSubscriptionsApi.getAll()).data.items ?? []
	});
}
